<template>
  <modal name="modal-edit-client-user" height="auto" :width="560"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head">
      <h4>{{ item?'EDIT':'ADD' }} CLIENT USER</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>FIRST NAME</label>
            <input type="text" class="form-control" ref="inputName" v-model="first_name">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>LAST NAME</label>
            <input type="text" class="form-control" v-model="last_name">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label>EMAIL ADDRESS</label>
          <input type="email" class="form-control" v-model="email">
        </div>
        <div v-if="!IS_CLIENT" class="form-group col">
          <label>COMPANY</label>
          <v-select v-model="client_id" :options="clients" class="form-control" :reduce="item => item.id"
                    label="name" :searchable="true"  placeholder="---"></v-select>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>Access Level</label>
            <select class="form-control" v-model="is_manager">
              <option value="">---</option>
              <option value="1">Client Manager</option>
              <option value="0">Client</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Status</label>
            <select class="form-control" v-model="enabled">
              <option value="">---</option>
              <option value="1">Active</option>
              <option value="0">Blocked</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="password">Password</label>
          <input type="password" name="password" id="password" class="form-control" v-model="password">
        </div>
        <div class="form-group col">
          <label for="password_confirmation">Retype Password</label>
          <input type="password" name="password_confirmation" id="password_confirmation" class="form-control" v-model="password_confirmation">
        </div>
      </div>
    </div>
    <div class="modal-foot">
      <div class="btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="button" class="btn btn-outline-black" @click="doSave">Save</button>
          <button type="button" class="btn btn-outline-gray" @click="closeModal">Close</button>
        </template>
      </div>
    </div>
  </modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import Service from '@/services/client'

  export default {
    components: {
      BeatLoader,
    },
    data () {
      return this.initialState();
    },
    props: ['value', 'item', 'clients', 'clientId'],
    computed: {
      ...mapGetters(['CURRENT_USER', 'IS_CLIENT']),
    },
    watch: {
      item: 'init',
      value ( newVal ) {
        let self = this;
        if ( newVal ) {
          this.$modal.show('modal-edit-client-user', {});
          setTimeout(() => {
            self.$refs.inputName.focus();
          }, 200);
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      initialState (){
        return {
          state: '',
          first_name: '',
          last_name: '',
          email: '',
          client_id: '',
          is_manager: '',
          enabled: '',
          password: '',
          password_confirmation: ''
        }
      },
      init () {
        let self = this;
        Object.assign(this.$data, this.initialState());
        if (self.IS_CLIENT)
          self.client_id = self.CURRENT_USER.client_id;
        if ( !self.item ) {
          return;
        }
        self.first_name = self.item.first_name;
        self.last_name = self.item.last_name;
        self.email = self.item.email;
        self.client_id = self.item.client_id;
        self.is_manager = self.item.is_manager;
        self.enabled = self.item.enabled;
        self.password = '';
        self.password_confirmation = '';
      },
      closeModal () {
        this.$modal.hide('modal-edit-client-user');
      },
      doSave ( ) {
        let self = this;

        if ( self.state == 'saving' ) {
          return;
        }

        let postData = {};

        if ( !self.item || self.first_name != self.item.first_name )
          postData.first_name = self.first_name;

        if ( !self.item || self.last_name != self.item.last_name )
          postData.last_name = self.last_name;

        if ( !self.item || self.email != self.item.email )
          postData.email = self.email;

        if ( !self.item || self.client_id != self.item.client_id )
          postData.client_id = self.client_id;

        if ( !self.item || self.is_manager != self.item.is_manager )
          postData.is_manager = self.is_manager;

        if ( !self.item || self.enabled != self.item.enabled )
          postData.enabled = self.enabled;

        if ( self.password ){
          if (self.password != self.password_confirmation) {
            self.$notify({
              type: 'error',
              text: 'Password and password confirmation does not match!'
            });
            return false;
          }
          postData.password = self.password;
          postData.password_confirmation = self.password_confirmation;
        }


        if (!self.isValid())
          return false;

        self.state = 'saving';
        if(self.item) {
          Service.saveMember(self.client_id, self.item.id, postData, itemData => {
            self.state = '';
            self.$notify({
              type: 'success',
              text: 'Client user updated successfully'
            });
            self.$emit('item-saved', itemData);
            Object.assign(self.$data, self.initialState());
            self.closeModal();
          }, () => {
            self.state = '';
          });
        }else{
          Service.createMember(self.client_id, postData, itemData => {
            self.state = '';
            self.$notify({
              type: 'success',
              text: 'Client user created successfully'
            });
            self.$emit('item-saved', itemData);
            Object.assign(self.$data, self.initialState());
            self.closeModal();
          }, () => {
            self.state = '';
          });
        }
      },
      isValid() {
        let self = this, requiredFields = {
          'first_name': 'Please enter first name',
          'last_name': 'Please enter last name',
          'email': 'Please enter the email',
          'client_id': 'Please select the company',
          'is_manager': 'Please select the access level',
          'enabled': 'Please select the status'
        };
        for(let f in requiredFields) {
          if (self[f] === '') {
            self.$notify({
              type: 'error',
              text: requiredFields[f]
            });
            return false;
          }
        }
        return true;
      }
    }
  }
</script>
